import {AfterViewInit, Directive, ElementRef} from "@angular/core";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {fromEvent} from "rxjs/observable/fromEvent";
import {switchMap, tap} from "rxjs/operators";

@Directive({
    selector: "[woa-touchable]"
})
/**
 * Directive to add "touched" class to an element while it is touched
 */
export class TouchableDirective implements AfterViewInit {
    public touched$: Subject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private element: ElementRef) {
    }

    ngAfterViewInit(): void {
        this.element.nativeElement.classList.add("touchable");

        const touchstart$: Observable<TouchEvent> = fromEvent(this.element.nativeElement, "touchstart", {passive: true});
        const touchend$: Observable<TouchEvent> = fromEvent(this.element.nativeElement, "touchend", {passive: true});
        const mousedown$: Observable<TouchEvent> = fromEvent(this.element.nativeElement, "mousedown", {passive: true});
        const mouseup$: Observable<TouchEvent> = fromEvent(this.element.nativeElement, "mouseup", {passive: true});

        touchstart$.pipe(
            tap(() => {
                this.element.nativeElement.classList.add("touched");
                this.touched$.next(true);
            }),
            switchMap(() => touchend$.pipe(
                tap(() => {
                    this.element.nativeElement.classList.remove("touched");
                    this.touched$.next(false);
                })
            )),
        ).subscribe();

        mousedown$.pipe(
            tap(() => {
                this.element.nativeElement.classList.add("touched");
                this.touched$.next(true);
            }),
            switchMap(() => mouseup$.pipe(
                tap(() => {
                    this.element.nativeElement.classList.remove("touched");
                    this.touched$.next(false);
                })
            )),
        ).subscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/touchable.directive.ts